export default __webpack_public_path__ + "static/media/2k_earth_normal_map.78290643.jpg";